import React from 'react';
import { Link } from 'react-router-dom';
import './Submenu.scss';
import { setDataAttr } from '../../../../utils/helper';

function subMenuList(
  submenu,
  updateNavValueDtm,
  subMenuData,
  section,
  subSection,
  categoryMenu,
  parentKey,
  menuKey
) {
  return submenu
    ? submenu.map(data => {
      return Object.keys(data).map((key, index) => {
        const dataAttr =
            data[key].gaObj && Object.keys(data[key].gaObj).length > 0
              ? setDataAttr(data[key].gaObj)
              : null;
        if (data[key].image) {
          const image = data[key].image;
          return (
              <div
                key={index}
                className={`nav-level-4 image ${section === 'Kids Glasses' ? 'level-5' : ''} `}
              >
                {data[key].url && data[key].url.indexOf('lenskart.com') === -1 ? (
                  <Link
                    {...dataAttr}
                    className="getGaData nav-level-4-item"
                    to={{
                      pathname: data[key].url,
                      state: { categoryId: data[key].categoryId, section: 'cat' },
                    }}
                    onClick={e =>
                      updateNavValueDtm(
                        section,
                        subSection,
                        categoryMenu,
                        parentKey,
                        e,
                        section + ' ' + subSection + ' ' + categoryMenu + ' ' + key
                      )
                    }
                  >
                    {section === 'Kids Glasses' && <img
                      alt={image.imgAlt}
                      className="img lazy-load-image"
                      src="https://static1.lenskart.com/media/desktop/img/GreyBackground.png"
                      data-src={image.src}
                    />}
                    {section === 'Kids Glasses' ? (
                      <div className="margin-t10">{key}</div>
                    ) : (
                      <span className="">{key}</span>
                    )}
                  </Link>
                ) : (
                  <a
                    {...dataAttr}
                    className="getGaData nav-level-4-item"
                    href={data[key].url}
                    onClick={e =>
                      updateNavValueDtm(
                        section,
                        subSection,
                        submenu,
                        categoryMenu,
                        parentKey,
                        e,
                        section + ' ' + subSection + ' ' + categoryMenu + ' ' + key
                      )
                    }
                  >
                    {section === 'Kids Glasses' && <img
                      alt={image.imgAlt}
                      className="img lazy-load-image"
                      src="https://static1.lenskart.com/media/desktop/img/GreyBackground.png"
                      data-src={image.src}
                    />}
                    <div className="margin-t10">{key}</div>
                  </a>
                )}
              </div>
          );
        }
        return (
            <div key={index} className="nav-level-4">
              {data[key].url && data[key].url.indexOf('lenskart.com') === -1 ? (
                <Link
                  {...dataAttr}
                  className="getGaData nav-level-4-item"
                  to={{
                    pathname: data[key].url,
                    state: { categoryId: data[key].categoryId, section: 'cat' },
                  }}
                  onClick={e =>
                    updateNavValueDtm(
                      section,
                      subSection,
                      categoryMenu,
                      key,
                      e,
                      section + ' ' + subSection + ' ' + categoryMenu + ' ' + menuKey + ' ' + key
                    )
                  }
                >
                  <span>{key}</span>
                  <i className="fa fa-angle-right hide"></i>
                </Link>
              ) : (
                <a
                  className="getGaData nav-level-4-item"
                  href={data[key].url}
                  onClick={e =>
                    updateNavValueDtm(
                      section,
                      subSection,
                      categoryMenu,
                      key,
                      e,
                      section + ' ' + subSection + ' ' + categoryMenu + ' ' + menuKey + ' ' + key
                    )
                  }
                >
                  <span>{key}</span>
                  <i className="fa fa-angle-right hide"></i>
                </a>
              )}
            </div>
        );
      });
    })
    : null;
}

const SubMenu = props => {
  const {
    submenu,
    updateNavValueDtm,
    subMenuData,
    section = '',
    subSection = '',
    categoryName = '',
    parentKey,
  } = props;
  const fetchSubMenu = submenu.map(data => {
    return Object.keys(data).map((key, index) => {
      const dataAttr =
        data[key].gaObj && Object.keys(data[key].gaObj).length > 0
          ? setDataAttr(data[key].gaObj)
          : null;
      return (
        <div
          key={index}
          className={
            data[key].type === 'image'
              ? `nav-level-3 flex-img-grow ${
                  section === 'Kids Glasses' ? 'display-flex justify-content-center' : ''
                }`
              : `nav-level-3 custom-width ${section === 'Kids Glasses' ? 'display-none' : ''}`
          }
        >
          {data[key].url && data[key].url.indexOf('lenskart.com') === -1 ? (
            <Link
              {...dataAttr}
              className={`getGaData nav-head display-block ${data[key].url ? '' : 'cursor-auto'}`}
              style={{ display: `${section === 'Kids Glasses' ? 'none' : ''}` }}
              to={data[key].url}
            >
              <span>{key}</span>
            </Link>
          ) : (
            <a
              {...dataAttr}
              className={`getGaData nav-head display-block ${data[key].url ? '' : 'cursor-auto'}`}
              href={data[key].url}
              style={{ display: `${section === 'Kids Glasses' ? 'none' : ''}` }}
            >
              <span>{key}</span>
              <i className="fa fa-angle-right hide"></i>
            </a>
          )}
          <div
            className={
              data[key].type === 'image'
                ? `layout ${
                    section === 'Kids Glasses'
                      ? 'justify-space-evenly justify-content-end align-items-center'
                      : 'flex-column align-items-start'
                  } `
                : ''
            }
          >
            {subMenuList(
              data[key].submenu,
              updateNavValueDtm,
              subMenuData,
              section,
              subSection,
              categoryName,
              parentKey,
              key
            )}
          </div>
        </div>
      );
    });
  });

  return (
    <div
      className={
        parentKey === 'See All'
          ? 'nav-subcategory-level fixFromTopDiv'
          : `nav-subcategory-level count_${submenu.length}`
      }
    >
      {fetchSubMenu}
    </div>
  );
};

export default SubMenu;
